import API from '@/api/apiUrls'
import { useApi } from '@/api/useApi'
import { defineStore } from 'pinia'

import type { ProjectUserType } from '@/stores/type/projectUser.type'
import { useBaseStore, useAuthModelBaseStore } from '@haskoning/vue-basestore'

const { api } = useApi()
const baseUrl = API.CORE.PROJECT_USERS.INDEX

const createEmptyProjectUser = (): ProjectUserType => ({
  id: 0,
  name: '',
  surname: '',
  email: '',
  project: 0,
  user: 0,
  role: 0
})

export const useProjectUserStore = defineStore('projectUsers', () => {
  const baseStore = useBaseStore<ProjectUserType>({ service: baseUrl, api })

  function resetState() {
    baseStore.items.value = []
    baseStore.currentItem.value = createEmptyProjectUser()
  }

  const { addUserDialog, toggleAddUserDialog, addUser, updateRole } = useAuthModelBaseStore({
    ...baseStore,
    resetState
  })

  return {
    ...baseStore,
    addUserDialog,
    toggleAddUserDialog,
    addUser,
    updateRole,
    resetState
  }
})
